define('blocks/banner/banner',['require','../../js/radar','store','../../js/actions'],function(require) {
    'use strict';
    var radar = require('../../js/radar');
    var store = require('store');
    var action = require('../../js/actions');
    var actionId = action.actionId;

    function showBanner(actionName) {
        var gaName = actionName + '-wl-banner';
        var key = gaName;
        var now = new Date();
        var tomorrow = new Date().setDate(now.getDate() + 1);
        var show = now > store.get(key);

        if (!show) {
            return;
        }
        var banner = document.querySelector('.js-action-banner');
        var closeBanner = banner.querySelector('.js-action-banner__close');

        banner.classList.add(actionName + '-banner');
        banner.classList.remove('hidden');

        radar.ga({
            category: gaName,
            action: 'show'
        });

        closeBanner.addEventListener('click', function(evt) {
            banner.classList.add('hidden');
            radar.ga({
                category: gaName,
                action: 'close'
            });
            evt.preventDefault();
            evt.stopPropagation();
        });

        banner.addEventListener('click', function(event) {
            banner.classList.add('hidden');

            radar.ga({
                category: gaName,
                action: 'click'
            });

            if (!window.__PH.activeUser || !window.__PH.activeUser()) {
                event.preventDefault();

                window.__PH.authForm.show({
                    successPage: banner.href || window.location.origin + '/subscriptions',
                    lang: 'ru_RU'
                });
            }
        });

        store.set(key, tomorrow.toString());
    }

    action.getFeatureAction.then(function(isFeatureAction) {
        if (isFeatureAction) {
            showBanner(actionId);
        }
    });
});

